import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { PwaService } from './pwa.service';
import { GlobalDataService } from './global.data.service';
import { TenantService } from './tenant.service';

@Injectable({ providedIn: 'root' })
export class TenantGuard implements CanActivate {
	constructor(
		private pwaService: PwaService,
		private globalDataService: GlobalDataService,
		private router: Router,
		private tenantService: TenantService
	) {}

	canActivate(): boolean {
		if (!this.globalDataService.pwaInfo$.getValue()) {
			const subdomain = this.tenantService.getTenant();
			if (subdomain) {
				this.pwaService.getPwaThemes(subdomain).subscribe({
					next: (res) => {
						return true;
					},
					error: (err) => {
						this.router.navigate(['/no-subdomain']);
						return false;
					},
				});
			} else {
				this.router.navigate(['/no-subdomain']);
				return false;
			}
		}
		return true;
	}
}
